<template>
  <div>
    <translate tag="h3"> Permitted arrival / departure time </translate>
    <slot>
      <permitted-arrival-departure-times v-bind="$attrs" />
    </slot>
    <div
      v-if="arrivalTime"
      class="arrival-time-custom"
      v-html="newlinesToHtmlBR(arrivalTime)"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { newlinesToHtmlBR } from '../../../../utility/newlinesToHtmlBR'

@Component
class PermittedArrivalDepartureTimesSection extends Vue {
  @Prop()
  arrivalTime: string

  newlinesToHtmlBR(string) {
    return newlinesToHtmlBR(string)
  }
}

export default toNative(PermittedArrivalDepartureTimesSection)
</script>

<style scoped>
p {
  margin: 0 0 1em;
  font-weight: bold;
}

.arrival-time-custom {
  border-bottom: 1px solid var(--colour-pale-blue);
  margin: -1em 0 1.5em;
  padding: 0 0 0.7em;
}
</style>
